import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

const ContentContainer = styled.div`
  margin-bottom: 40px;
`;

const Form = styled.form``;

const CallToActionContainer = styled.div`
  margin-top: 70px;
  display: flex;
  flex-direction: column;
  > button + button {
    margin-top: 24px;
  }

  @media ${device.isTabletAndAbove} {
    flex-direction: row-reverse;

    > button {
      & + button {
        margin-top: 0;
        margin-right: 24px;
      }
    }
  }
`;

export { ContentContainer, Form, CallToActionContainer };
